import { ERichModalFileParseStatus } from "../file/types";

export enum ESessionStatus {
  work = "work",
  invalid = "invalid",
  history = "history",
}

export interface ISession {
  tempId?: string;
  session_id: string;
  status: ESessionStatus;
  time: string;
  title: string;
  total_token?: number;
  is_top?: boolean;
  is_deleted?: boolean;
  file_list?: ISessionFile[];
}

export enum ESessionType {
  top = "top",
  today = "today",
  week = "week",
  month = "month",
  year = "year",
  earlier = "earlier",
}

export interface ISessionGroup {
  type: ESessionType;
  session_list: ISession[];
}

export interface ISessionFile {
  type: ESessionFileType;
  content_type?: string; // 文件类型，例如： image/png、text/plain、text/html
  file_id?: string;
  file_name: string; // type是link时，name代表输入url
  total_page?: number;
  url: string; // 文件Url，外网可以直接获取 或网页原文
  size?: number;
  token?: number;
  status: ESessionFileStatus | ERichModalFileParseStatus;
  contentParseStatus: ESessionFileContentParseStatus; // 文件内容解析状态
  contentParseRes?: ILinkFileContent;
}

export interface ILinkFileContent {
  sourceIcon?: string;
  source?: string;
  title?: string;
  url?: string;
  desc?: string;
}

export enum ESessionFileContentParseStatus {
  "pending" = "pending",
  "parsing" = "parsing",
  "success" = "success",
  "failed" = "failed",
}

export enum ESessionFileType {
  file = "file",
  image = "image",
  link = "link",
}

export enum ESessionFileStatus {
  success = "success",
  failed = "failed",
  deleted = "deleted",
}
